import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://2eaaf7ea7b97acaf71770ae0bd247d78@o4509163070685184.ingest.de.sentry.io/4509163301044304",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,      // disables text masking
      blockAllMedia: false,    // allows media (e.g., video/audio) to be captured
      maskAllInputs: false,    // disables input masking
      unblock: [".sentry-unblock, [data-sentry-unblock]"],
      unmask: [".sentry-unmask, [data-sentry-unmask]"],
    }),
  ],
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0 
});
